import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteJson, getJson, postJson } from '../../helpers/RequestsHelper'

import Modal from 'react-bootstrap/Modal'
import ConfirmationPopup from '../../components/ConfirmationPopup'
import { validateEmail } from '../../helpers/utils';

const WorkflowShares = (props) => {

  const [workflowId] = useState(props.workflowId)
  const [email, setEmail] = useState()
  const [shares, setShares] = useState()
  const [loading, setLoading] = useState()
  const [deleteId, setDeleteId] = useState()

  const { t } = useTranslation()

  const url = process.env.REACT_APP_SERVER_BASE_URL + "/workflows/" + workflowId + "/shares"

  const popupId = "shares" + workflowId
  const [showPopup, setShowPopup] = useState(sessionStorage.getItem("PopupVisible") === popupId)

  useEffect(() => {
    if (!shares) {
      fillShares()
    }
  })

  const fillShares = async () => {
    if (loading) {
      return
    }
    setLoading(true)
    const userShares = await getJson(url)
    setShares(userShares)
  }

  const onShowShares = () => {
    setShowPopup(true)
  }

  const onSubmit = async () => {
    const newShareId = await postJson(url, { email })
    setShares(shares => [...shares, { _id: newShareId, email }])
  } 
  
  const onDelete = async (id) => {
    await deleteJson(url + "/" + id)
    setShares(shares.filter(a=>a._id !== id))
  }

  return <div>
    <Modal show={showPopup} onHide={() => { setShowPopup(false) }} >
      <Modal.Header closeButton>
        <Modal.Title>Share with people</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="validate-input w-400">
        <span className="label-input100">{t("lbl_email")}</span>
        <input className="form-control"
          type="email"
          name="email"
          autoComplete="email"
          id="email"
          placeholder={t("tip_share_email")}
          onChange={(e) => setEmail(e.target.value.toLowerCase())}
          required={true} />
        <span className="focus-input100" data-symbol="&#xf1fa;"></span>
      </div>
        <br />
        {email && validateEmail(email) ? 
        <button type="button" className="submit-btn" data-dismiss="modal" onClick={onSubmit}>Share</button>
          : <small id="errorMessage" className="text-danger">Please enter a valid email address</small>}
                      
        <br /><br />
        {shares != null? shares.map(share =>
          <div key={share._id}>
            <table className="icons-list"><tbody><tr>
              <td>{share.email}</td>
              <td className="icons-list-item"><button onClick={(event) => { event.stopPropagation(); event.preventDefault(); setDeleteId(share._id); return false; }} className="btn btn-default icons-list-item"><i className="fa fa-trash"></i></button></td>
            </tr></tbody></table>
          </div>) : null}
      </Modal.Body>

    </Modal>
    <div className="p-2">
      <button className="submit-btn-2" onClick={() => setShowPopup(true)}>Share</button>
    </div>
    <ConfirmationPopup show={deleteId && deleteId !== 0}
                title={t("warning")}
                onConfirm={() => { setDeleteId(0); onDelete(deleteId); }}
                onHide={() => setDeleteId(0)}
                text={t("lblsharedeleteconfirm")}
                buttonText={t("btndeleteconfirm")} />
  </div>
}

export default WorkflowShares

